import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1301cd84"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "playCount"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-play4"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_3 = {
  key: 1,
  class: "author"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-user1"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_5 = {
  key: 2,
  class: "update"
};
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  key: 3,
  class: "musicCount"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _directive_thousand = _resolveDirective("thousand");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" 播放量 "), _ctx.playCount ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _withDirectives((_openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString(_ctx.playCount), 1
  /* TEXT */
  )])), [[_directive_thousand]])])) : _createCommentVNode("v-if", true), _createCommentVNode(" 作者 "), _ctx.author ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", null, _toDisplayString(_ctx.author), 1
  /* TEXT */
  )])) : _createCommentVNode("v-if", true), _createCommentVNode(" 更新时间 "), _ctx.update ? (_openBlock(), _createElementBlock("div", _hoisted_5, [typeof _ctx.update === 'string' ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.update), 1
  /* TEXT */
  )) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true), _createCommentVNode(" 曲目数量 "), _ctx.musicCount ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", null, "曲目数：" + _toDisplayString(_ctx.musicCount), 1
  /* TEXT */
  )])) : _createCommentVNode("v-if", true), _createCommentVNode(" 视频播放时间 "), _ctx.playTime ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: "playTime",
    style: _normalizeStyle({
      bottom: ~_ctx.route.path.indexOf('/artistdetail') ? '35px' : '60px'
    })
  }, [_createElementVNode("div", null, _toDisplayString(_ctx.$filters.formatTime(_ctx.playTime, "mm:ss")), 1
  /* TEXT */
  )], 4
  /* STYLE */
  )) : _createCommentVNode("v-if", true)], 64
  /* STABLE_FRAGMENT */
  );
}